import { render, staticRenderFns } from "./Usp.vue?vue&type=template&id=2fa31732&"
import script from "./Usp.vue?vue&type=script&lang=js&"
export * from "./Usp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OpusTitle: require('/~/src/modules/opus/components/Title.vue').default})
